import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from '@/page/vue/2023/isc.vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import 'animate.css'
import '@/styles/index.scss'
import initShare from '@/utils/wxShare.js'
import tongji from '@/utils/tongji.js'; //引入统计

import Qapm from '@q/qapm';
Qapm('init', {
    appKey: 'isc',
    env: import.meta.env.MODE,
    ratio: 100,
});

tongji(); //统计
initShare({
  title: 'ISC 2023盛幕将启，全球议题火热征集中！',
  desc: '2023.8.9 北京国家会议中心',
  imgUrl: 'https://p0.ssl.qhimg.com/t01dc36787d18ac8ede.png',
  link: window.location.href
})

const pinia = createPinia()
const app = createApp(App)

app.use(pinia)
app.use(Antd)
app.mount('#app')
